import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import router from './router/index'
import App from './App.vue';
import './style.css';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';

import '@/font/font.css';

const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
}
app.use(router);
app.use(ElementPlus);
app.mount('#app');
